// Los valores válidos de rol y momento de la biblioteca (`VALID_ROLES` / `VALID_MOMENTOS` del
// Backend), en el orden del producto. Los rótulos son las claves existentes
// `prompt_library.roles.*` y `prompt_library.momentos.*`.
export const ROLES = ['media_buyer', 'analista', 'account', 'director'];
export const MOMENTOS = ['dia_a_dia', 'semanal', 'antes_reunion', 'cierre_mes', 'cuando_cambio', 'cliente_nuevo'];
